<template>
    <or-layout>

        <div>
            <a-form layout="inline">
                <a-form-item>
                    <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                        :placeholder="['答题开始时间', '答题结束时间']" @change="onChange" />

                </a-form-item>
                <a-form-item>
                    <a-select v-model="seachitem.campus_id" placeholder="校区" style="width: 150px;" allow-clear>
                        <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-select v-model="seachitem.grade_id" placeholder="年级" style="width: 150px;" allow-clear>
                        <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" style="margin-left: 20px;" htmlType="submit" icon="search"
                        @click="tableSearch"></a-button>
                </a-form-item>
            </a-form>
            <br>

            <div>
                <a-tabs class="row" type="card">
                    <a-tab-pane tab="题目信息" key="questioninfo">
                        <div style="padding-bottom: 20px;">
                            <a herf="#" @click="yinchang(1)" v-show="timushow">隐藏题目</a>
                            <a herf="#" @click="yinchang(0)" v-show="!timushow">显示题目</a>
                        </div>
                        <a-row type="flex" justify="space-between" style="margin-top: 1.5rem;">
                            <div v-show="timushow">
                                <div>
                                    <div slot="title">
                                        <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                            v-if="item.typestr == 'ANSWER'">问答题
                                        </a-tag>
                                        <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                            v-if="item.typestr == 'PREVIEW'">预习题
                                        </a-tag>
                                        <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                            v-if="item.typestr == 'JUDGMENT'">判断题
                                        </a-tag>
                                        <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                            v-if="item.typestr == 'COMPLETION'">填空题
                                        </a-tag>
                                        <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                            v-if="item.typestr == 'VIDEO'">口述题
                                        </a-tag>
                                        <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                            v-if="item.typestr == 'SINGLE_CHOICE'">单选题
                                        </a-tag>
                                        <span style="color: #aeaeae" v-if="item.node_str != ''">[{{ item.node_str }}]</span>
                                        <div v-html="item.title" />
                                    </div>
                                    <div>
                                        <span v-if="item.typestr == 'ANSWER' || item.typestr == 'VIDEO'">参考答案:</span>
                                        <span v-if="item.typestr == 'JUDGMENT' || item.typestr == 'SINGLE_CHOICE'">答案:</span>
                                        <span
                                            v-if="item.typestr == 'COMPLETION'">答案(共计{{ item.answer_cnt }}个输入项,其中|符号为分隔符):</span>
                                        <span
                                            v-if="item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">{{ item.answer }}</span>
                                        <span v-if="item.typestr == 'JUDGMENT' && item.answer == 1">正确</span>
                                        <span v-if="item.typestr == 'JUDGMENT' && item.answer == 0">错误</span>
                                    </div>
                                    <template slot="description">

                                        <a-row :gutter="16" v-if="item.typestr == 'SINGLE_CHOICE'">
                                            <a-col :span="6" v-for="option in item.options" :key="option.keys">
                                                <div class="option">
                                                    <label class="label">{{ option.keys }}:</label>
                                                    <div class="span" v-html="option.value" />
                                                </div>
                                            </a-col>
                                        </a-row>
                                    </template>
                                </div>


                                <div v-if="item.typestr != 'PREVIEW'"
                                    style="margin: 20px;padding: 20px; background-color: #DBDBDB;">
                                    <h4>解析:</h4>
                                    <div v-html="item.analysis" />
                                </div>

                                <a-row type="flex" justify="space-between">
                                    <div>
                                        <a-divider type="vertical" />
                                    </div>
                                </a-row>
                            </div>

                        </a-row>

                    </a-tab-pane>

                    <a-tab-pane tab="做题列表" key="userlist">
                        <a-table :dataSource="userquestion" :rowKey="item => item.id" :pagination="pageinfo"
                            :loading="loading" @change="onPaginationChange" bordered style="padding-top: 10px;">
                            <a-table-column key="campus_name" title="校区" data-index="campus_name" />
                            <a-table-column key="grade_name" title="年级" data-index="grade_name" />
                            <a-table-column key="name" title="班级" data-index="name" />

                            <a-table-column key="user_name" title="姓名" data-index="user_name" />
                            <a-table-column key="user_answer" title="学生答案">
                                <template slot-scope="item">
                                    <img style="cursor: zoom-in" :preview="item.id"
                                        :large="item.user_answer + '?x-oss-process=image/resize,w_800/auto-orient,1'"
                                        :preview-text="'学生回答'"
                                        :src="item.user_answer + '?x-oss-process=image/resize,w_100,h_80/auto-orient,1'"
                                        v-if="item.typestr == 'ANSWER'" />

                                    <a-button type="primary" @click="video_path = item.user_answer; video_visible = true;"
                                        v-if="item.typestr == 'VIDEO'">播放</a-button>

                                    <template v-if="item.typestr == 'PREVIEW'">
                                        an <span
                                            v-if="item.isright == 1 && item.correct == 1">{{ Math.floor(item.user_answer / 1000 / 60) }}分{{ Math.floor((item.user_answer / 1000) % 60) }}秒</span>
                                        <span v-if="item.isright == 0 && item.correct == 0">未观看</span>
                                    </template>
                                    <span
                                        v-if="item.typestr == 'JUDGMENT' || item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">{{ item.user_answer }}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="correct" title="对错" :width="60">
                                <template slot-scope="item">
                                    <span v-if="item.correct == 0">未批改</span>
                                    <a-icon v-if="item.isright == 0 && item.correct == 1" type="close"
                                        :style="{ fontSize: '22px', color: 'red' }" />
                                    <a-icon v-if="item.isright == 1 && item.correct == 1" type="check"
                                        :style="{ fontSize: '22px', color: 'green' }" />
                                </template>
                            </a-table-column>
                            <a-table-column key="tj_time" title="时间" :width="180">
                                <template slot-scope="item">
                                    <span>{{ moment(item.tj_time * 1000).format('lll') }}</span>
                                </template>
                            </a-table-column>
                        </a-table>

                    </a-tab-pane>

                    <a-tab-pane tab="班级列表" key="classinfo">

                        <a-row class="row" :gutter="16">
                            <a-col :span="2">
                                <a-statistic title="总数" :value="gradeinfo.sum" />
                            </a-col>
                            <a-col :span="2">
                                <a-statistic title="正确数" :value="gradeinfo.isrightcount" />
                            </a-col>
                            <a-col :span="2">
                                <a-statistic title="错误数" :value="gradeinfo.notisrightcount" />
                            </a-col>
                            <a-col :span="2">
                                <a-statistic title="未完成数" :value="gradeinfo.notwancheng" />
                            </a-col>
                            <!--a-col :span="2">
                                <a-statistic title="未完成数" />
                            </a-col>
                            <a-col :span="2">
                                <a-statistic title="参测率">
                                    <template #suffix>
                                        <span>%</span>
                                    </template>
                                </a-statistic>
                            </a-col-->
                            <a-col :span="2">
                                <a-statistic title="正确率"
                                    :value="parseFloat((gradeinfo.isrightcount / (gradeinfo.isrightcount + gradeinfo.notisrightcount)) * 100).toFixed(2)">
                                    <template #suffix>
                                        <span>%</span>
                                    </template>
                                </a-statistic>
                            </a-col>
                            <a-col :span="2">
                                <a-statistic title="完成率"
                                    :value="parseFloat((1 - (gradeinfo.notwancheng / gradeinfo.sum)) * 100).toFixed(2)">
                                    <template #suffix>
                                        <span>%</span>
                                    </template>
                                </a-statistic>
                            </a-col>
                        </a-row>

                        <a-table :dataSource="squadlist" :rowKey="item => item.id" :pagination="pageinfocut99"
                            :loading="loading" bordered style="padding-top: 10px;">
                            <a-table-column key="campus_name" title="校区" data-index="campus_name" />
                            <a-table-column key="grade_name" title="年级" data-index="grade_name" />
                            <a-table-column key="name" title="班级" data-index="name" />

                            <a-table-column key="isrightcount" title="正确数" :width="130">
                                <template slot-scope="item">
                                    {{ item.isrightcount }}
                                </template>
                            </a-table-column>
                            <a-table-column key="isrightcount" title="错误数" :width="130">
                                <template slot-scope="item">
                                    {{ item.notisrightcount }}
                                </template>
                            </a-table-column>

                            <a-table-column key="rightlv" title="正确率" :width="180"
                                :sorter="(item1, item2) => item1.rightlv - item2.rightlv">
                                <template slot-scope="item">
                                    <a-progress :percent="parseFloat(item.rightlv * 100).toFixed(2)" status="active"
                                        size="small" />
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane tab="老师列表" key="teacherinfo">
                        <a-table :dataSource="teacherlist" :rowKey="item => item.id" :loading="loading"
                            :pagination="pageinfocut99" bordered style="padding-top: 10px;">
                            <a-table-column key="teacher_name" title="老师姓名" data-index="teacher_name" />
                            <a-table-column key="isrightcount" title="正确数" :width="130">
                                <template slot-scope="item">
                                    {{ item.isrightcount }}
                                </template>
                            </a-table-column>
                            <a-table-column key="isrightcount" title="错误数" :width="130">
                                <template slot-scope="item">
                                    {{ item.notisrightcount }}
                                </template>
                            </a-table-column>

                            <a-table-column key="rightlv" title="正确率"
                                :sorter="(item1, item2) => item1.rightlv - item2.rightlv" :width="180">
                                <template slot-scope="item">
                                    <a-progress :percent="parseFloat(item.rightlv * 100).toFixed(2)" status="active"
                                        size="small" />
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-tab-pane>
                </a-tabs>

            </div>
            <a-modal :visible="video_visible" title="视频播放" @ok="video_visible = false" :destroyOnClose="true" :footer="null"
                @cancel="video_visible = false">
                <video :src="video_path" style="max-width: 100%;max-height: 300px;" autoplay controls />
                <div style="text-align: right;margin-top: 1rem;">
                    <a-button type="primary" @click="video_visible = false">关闭</a-button>
                </div>
            </a-modal>
        </div>
    </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from "moment";
export default {
    components: {
        AFormItem
    },
    data() {
        return {
            timushow: true,
            id: this.$route.params.id,
            seachitem: {
                id: this.$route.params.id,
                starttime: undefined,
                endtime: undefined,
                campus_id: undefined,
                grade_id: undefined,
            },
            video_path: undefined,
            video_visible: false,
            teacherlist: [],
            campusList: [],
            gradeList: [],
            gradeinfo: [],
            questioninfo: {
                isrightcount: undefined,
            },
            questionTypes: [{
                id: "ANSWER",
                name: "问答题",
            },
            {
                id: "VIDEO",
                name: "口述题",
            },
            {
                id: "PREVIEW",
                name: "预习题",
            },
            {
                id: "JUDGMENT",
                name: "判断题",
            },
            {
                id: "COMPLETION",
                name: "填空题",
            },
            {
                id: "SINGLE_CHOICE",
                name: "单选题",
            },
            ],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            pageinfocut99: {
                total: 1,
                current: 1,
                pageSize: 99
            },

            userquestion: [],
            squadlist: [],
            item: [],
            loading: false,

        };
    },
    mounted() {
        if (this.id != 0) {
            this.getQuestionFind(this.id);
        }
        this.getCampusList();
        this.getGradeList();
        // this.getUserQuestion(this.seachitem);
    },
    methods: {
        searchBtn() {


        },




        getGradeList() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.gradeList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCampusList() {
            this.$axios
                .post("/api/Admin/getorgsquadlist")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"

                        });
                    } else {
                        this.campusList = res.data.org_campus;
                        this.tableSearch();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        onChange(value, dateString) {
            dateString,
                this.seachitem.starttime = Number(value[0] / 1000);
            this.seachitem.endtime = Number(value[1] / 1000);
        },
        tableSearch() {
            this.getUserQuestion(this.seachitem);
        },
        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getUserQuestion(this.seachitem);
        },
        yinchang(no) {
            this.timushow = false;
            if (no == 1) {
                this.timushow = false;
            } else {
                this.timushow = true;
            }
        },

        getUserQuestion(seachitem) {
            this.$axios
                .post("/api/QuestionProblems/getUserProblemsbyTime", {
                    data: seachitem,
                    pageinfo: this.pageinfo,
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                        return false;
                    }
                    this.userquestion = res.data.data;
                    this.pageinfo = res.data.pageinfo;
                    this.squadlist = res.data.squadlist;
                    this.gradeinfo = res.data.gradeinfo;
                    this.teacherlist = res.data.groupteacher;
                    //  this.item = res.data.info;

                })
                .catch((err) => {
                    console.error(err);
                });

        },
        getQuestionFind(id) {
            this.$axios
                .post("/api/QuestionProblems/find", {
                    data: {
                        id: id,
                    },
                    pageinfo: this.pageinfo,
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                        return false;
                    }
                    this.questioninfo = res.data.info;
                    this.item = res.data.info;

                })
                .catch((err) => {
                    console.error(err);
                });
        },
        moment
    },


}
</script>

<style lang="less" scoped>
.wrapper {
    width: 80rem;
    margin-left: 12rem;
}

.filter-group {
    label {
        font-weight: bold;
        margin-right: 0.5rem;
        text-align: right;
        display: inline-block;
    }
}

.option {
    display: flex;

    .label {
        font-weight: bold;
    }

    .span {
        width: 0;
        flex: 1;
        margin-left: 0.5rem;
    }
}

.remove {
    color: #ff0000;
}

.problems_statistic_main {
    .problems_statistic_title {
        font-size: 16px;
        /*margin-left: 10px;*/
    }

    .problems_statistic_value {
        font-size: 16px;
        font-weight: bold;
        color: red;
    }
}
</style>
